export function parseChecklist(value) {
    if (!value) return [];
    let raw = value;
    if (typeof raw === "string") {
        try {
            raw = JSON.parse(raw);
        } catch {
            return [];
        }
    }
    if (!Array.isArray(raw)) return [];
    return raw
        .map((item, index) => ({
            id: String(item?.id || `c-${index}`),
            text: String(item?.text || "").trim(),
            required: Boolean(item?.required),
            photoRequired: Boolean(item?.photoRequired),
            photo: item?.photo || null,
            done: Boolean(item?.done),
            doneAt: item?.doneAt || null,
            doneBy: item?.doneBy || null,
        }))
        .filter((item) => item.text);
}

export function createChecklistItem(text, required = false, photoRequired = false) {
    return {
        id: `c-${Date.now()}-${Math.random().toString(36).slice(2, 7)}`,
        text: String(text || "").trim(),
        required: Boolean(required),
        photoRequired: Boolean(photoRequired),
        photo: null,
        done: false,
        doneAt: null,
        doneBy: null,
    };
}

export function incompleteRequiredChecklist(taskOrList) {
    const list = Array.isArray(taskOrList)
        ? parseChecklist(taskOrList)
        : parseChecklist(taskOrList?.checklist);
    return list.filter((item) => item.required && !item.done);
}

export function missingChecklistPhotos(taskOrList) {
    const list = Array.isArray(taskOrList)
        ? parseChecklist(taskOrList)
        : parseChecklist(taskOrList?.checklist);
    return list.filter((item) => item.photoRequired && !item.photo);
}

export function checklistBlocksComplete(taskOrList) {
    const open = incompleteRequiredChecklist(taskOrList);
    const photos = missingChecklistPhotos(taskOrList);
    if (open.length > 0) {
        return `Complete ${open.length} required checklist item${open.length === 1 ? "" : "s"} first`;
    }
    if (photos.length > 0) {
        return `Add photo proof for ${photos.length} checklist step${photos.length === 1 ? "" : "s"} first`;
    }
    return null;
}

export function checklistProgress(taskOrList) {
    const list = Array.isArray(taskOrList)
        ? parseChecklist(taskOrList)
        : parseChecklist(taskOrList?.checklist);
    return {
        total: list.length,
        done: list.filter((item) => item.done).length,
    };
}

export function toggleChecklistItem(list, itemId, actor = null) {
    return parseChecklist(list).map((item) => {
        if (item.id !== String(itemId)) return item;
        if (item.photoRequired && !item.photo && !item.done) {
            return item;
        }
        const done = !item.done;
        return {
            ...item,
            done,
            doneAt: done ? new Date().toISOString() : null,
            doneBy: done ? actor : null,
        };
    });
}

export function resetChecklistForTemplate(value) {
    return parseChecklist(value).map((item) => ({
        ...item,
        done: false,
        doneAt: null,
        doneBy: null,
        photo: null,
    }));
}

export function taskFileUrl(apiUrl, filePath) {
    if (!filePath) return null;
    const value = String(filePath);
    if (/^https?:\/\//i.test(value)) return value;
    const base = String(apiUrl || "").replace(/\/+$/, "");
    const rel = value.replace(/^\/+/, "");
    return `${base}/${rel}`;
}
